/**
 * Centralized React Query key factory. Group by feature and use the helper
 * tuples (`queryKeys.echoes.public(filters)`, `queryKeys.chat.history(echoId)`)
 * so invalidations stay coherent across hooks.
 */
export const queryKeys = {
  auth: {
    user: ['auth', 'user'] as const,
  },
  echoes: {
    all: ['echoes'] as const,
    public: (filters?: Record<string, unknown>) => ['echoes', 'public', filters] as const,
    trending: ['echoes', 'trending'] as const,
    mine: ['echoes', 'mine'] as const,
    drafts: ['echoes', 'drafts'] as const,
    detail: (id: string) => ['echoes', 'detail', id] as const,
  },
  chat: {
    root: ['chat'] as const,
    history: (echoId: string) => ['chat', 'history', echoId] as const,
    lastMessage: (echoId: string) => ['chat', 'last-message', echoId] as const,
  },
  stats: {
    root: ['stats'] as const,
    echo: (echoId: string) => ['stats', 'echo', echoId] as const,
    echoesBatch: (echoIds: readonly string[]) => ['stats', 'echoes-batch', echoIds] as const,
  },
  earnings: {
    echo: (echoId: string) => ['earnings', 'echo', echoId] as const,
  },
  credits: {
    root: ['credits'] as const,
    balance: ['credits', 'balance'] as const,
    packages: ['credits', 'packages'] as const,
    transactions: ['credits', 'transactions'] as const,
    pricing: ['credits', 'pricing'] as const,
  },
  billing: {
    root: ['billing'] as const,
    options: ['billing', 'options'] as const,
    current: ['billing', 'current'] as const,
    invoices: (year: number, month: number) => ['billing', 'invoices', year, month] as const,
  },
  notifications: {
    all: ['notifications'] as const,
  },
  surveys: {
    active: ['surveys', 'active'] as const,
  },
  taxonomy: {
    domains: ['taxonomy', 'domains'] as const,
    categories: ['taxonomy', 'categories'] as const,
  },
};
